import { Dropdown, IDropdownOption } from '@fluentui/react';
import React from 'react';
import { useGetStorefrontsQuery } from '../../store/endpoints/StorefrontSettingsEndpoints';
import { useGetInstalledExtensionsQuery } from '../../store/Api';
import {
    STOREFRONT_WEBHOOK_TYPES,
    WEBHOOK_TYPE_EXTENSION_ERROR,
} from '../../models/Webhooks';

interface IWebhookidsDropdownProps {
    type: string;
    enabledIds?: string[];
    onChange: (enabledIds: string[]) => void;
    disabled?: boolean;
}

const WebhookIdsDropdown: React.FC<IWebhookidsDropdownProps> = (props) => {
    const [options, setOptions] = React.useState<IDropdownOption[]>([]);
    const storefronts = useGetStorefrontsQuery();
    // Folios + standalone extensions, for scoping an extension_error webhook. For a folio the activity log
    // is keyed by the folio source id; for a standalone extension by its installed id — match those here.
    const installedExtensions = useGetInstalledExtensionsQuery(undefined, { skip: props.type !== WEBHOOK_TYPE_EXTENSION_ERROR });

    React.useEffect(() => {
        if (STOREFRONT_WEBHOOK_TYPES.includes(props.type)) {
            if (storefronts.data) {
                const opts = storefronts.data.items.map(sf => ({
                    key: sf.id || '',
                    text: sf.name || 'Unnamed Storefront',
                    selected: props.enabledIds?.includes(sf.id || '') || false
                }));
                setOptions(opts);
            }
        } else if (props.type === WEBHOOK_TYPE_EXTENSION_ERROR) {
            if (installedExtensions.data) {
                const opts = installedExtensions.data
                    // Only whole folios (the facade entry, keyed by folio source) and standalone extensions
                    // (keyed by their id) — not a folio's individual sub-extensions.
                    .filter(ext => !ext.isSubExtension)
                    .map(ext => {
                        const key = ext.extensionType === 'Folio' ? ext.source : ext.id;
                        return {
                            key: key || '',
                            text: ext.nickname || ext.name || 'Unnamed Extension',
                            selected: props.enabledIds?.includes(key || '') || false
                        };
                    });
                setOptions(opts);
            }
        }
    }, [props.type, storefronts.data, installedExtensions.data]);

    return (<div>
        <Dropdown
            label='Enabled For'
            options={options}
            selectedKeys={props.enabledIds}
            onChange={(e, v) => {
                if (!v) return;
                props.onChange(v.selected ? [...(props.enabledIds || []), v.key as string] : (props.enabledIds || []).filter(id => id !== v.key));
            }}
            multiSelect
            disabled={props.disabled || storefronts.isFetching || installedExtensions.isFetching}
            />
    </div>);
};

export default WebhookIdsDropdown;